import { useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

export const MoreInfoButton = (props: PropsWithClassName) => {
  const navigate = useNavigate();
  const { updateTourney } = useTourney();
  const { isMobile } = useIsDesktop();

  const handleMoreInfo = () => {
    if (isMobile) {
      navigate(ROUTES.goldDate.info);
    } else {
      updateTourney({ showModalInfo: true });
    }
  };

  return (
    <Button
      className={cn('text-gdt-blue font-bold', props.className)}
      type="button"
      variant="text"
      onClick={handleMoreInfo}
    >
      Más información
    </Button>
  );
};
